import { useReducer } from 'react'

export const useForceUpdate = (): (() => void) => {
    const [, forceUpdate] = useReducer(() => ({}), {})
    return forceUpdate
}
